import React from "react";

import { Box } from "@whoosh/design-system/src/components/primitive";

const SPOT_STYLE_CONFIG = {
  MEMBER: {
    bg: "surface-main-primary-subtlest" as const,
    borderColor: "outline-main-primary" as const,
  },
  GUEST: {
    bg: "surface-main-secondary-subtlest" as const,
    borderColor: "outline-main-secondary" as const,
  },
  CUSTOMER: {
    bg: "surface-user-selectable-colorC-subtle" as const,
    borderColor: "outline-primary" as const,
  },
  FLEX: {
    bg: "surface-secondary" as const,
    borderColor: "outline-default" as const,
  },
} as const;

export type SpotType = keyof typeof SPOT_STYLE_CONFIG;

type Props = {
  type: SpotType;
  index: number;
};

export const RequiredSpot = ({ type, index }: Props) => {
  const { bg, borderColor } = SPOT_STYLE_CONFIG[type];

  return (
    <Box
      width={40}
      height={40}
      bg={bg}
      borderColor={borderColor}
      borderStyle="dashed"
      borderRadius="1"
      alignItems="center"
      justifyContent="center"
      borderWidth={1.5}
      testID={`required-spot-${type}-${index}`}
    />
  );
};
